import ReportDevelopment from "./ReportDevelopment";
import ReportProduction from "./ReportProduction";

const getReport = () => {
  if (process.env.REACT_APP_STATE == "PRODUCTION") {
    return ReportProduction;
  }
  return ReportDevelopment;
};

export default getReport();
